module.exports = __webpack_public_path__ + "static/media/KW.3c06184f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/KW.svg
// module id = 2190
// module chunks = 7